import React from "react"
import { useAtom as GetAtom } from "jotai"
import { Item } from "../../libs/api/backend/src"
import {
  useEnterpriseGetOne,
  useMainEnterpriseId,
} from "../../hooks/enterprise"
import { useShopGetOne, useShopId } from "../../hooks/shop"
import ItemStackedList from "./ItemStackedList"
import { useItemSearch, useItemSearchText } from "../../hooks/item"
import { checkoutItemsAtom } from "../../store/checkout"

export default function ItemList() {
  const enterpriseId = useMainEnterpriseId()
  const shopId = useShopId()
  const searchText = useItemSearchText()
  const [checkoutItems, setCheckoutItems] = GetAtom(checkoutItemsAtom)

  const { isLoading: isLoadingEnterprise, isError: isErrorEnterprise } =
    useEnterpriseGetOne(enterpriseId)
  const { isLoading: isLoadingShop, isError: isErrorShop } = useShopGetOne(
    enterpriseId,
    shopId
  )
  const {
    items,
    isLoading: isLoadingItems,
    isError: isErrorItems,
  } = useItemSearch(enterpriseId, searchText, {
    shopId,
  })

  const onClickItemRow = (item: Item) => {
    const newCheckoutList = [...checkoutItems]
    let isFound = false

    for (let i = 0; i < newCheckoutList.length; i++) {
      if (item.id === newCheckoutList[i].id) {
        isFound = true
        const currentCount = Number(newCheckoutList[i].count) || 0
        newCheckoutList[i] = {
          ...newCheckoutList[i],
          count: String(currentCount + 1),
        }
      }
    }

    if (!isFound) {
      newCheckoutList.push({
        ...item,
        count: "1",
      })
    }

    setCheckoutItems(newCheckoutList)
  }

  const getItemsWithoutCheckout = (
    items: Array<Item>,
    checkoutItems: Array<Item>
  ): Array<Item> => {
    if (!items || !items.length) {
      return []
    }

    const checkoutMap = new Map<string, number>()
    for (const c of checkoutItems) {
      checkoutMap.set(c.id, Number(c.count) || 0)
    }

    const newItems: Array<Item> = []
    for (const item of items) {
      const checkoutCount = checkoutMap.get(item.id) || 0
      const totalCount = Number(item.count) || 0

      if (checkoutCount === 0) {
        newItems.push(item)
      } else if (totalCount > checkoutCount) {
        newItems.push({
          ...item,
          count: String(totalCount - checkoutCount),
        })
      }
    }

    return newItems
  }

  if (
    isLoadingEnterprise ||
    isErrorEnterprise ||
    isLoadingShop ||
    isErrorShop
  ) {
    return null
  }

  if (!searchText) {
    return (
      <p className="p-6 text-sm text-muted-foreground">
        Отсканируйте штрихкод или введите название/штрихкод вручную
      </p>
    )
  }

  if (isLoadingItems) {
    return <p className="p-6 text-sm text-muted-foreground">Поиск товара...</p>
  }

  if (isErrorItems) {
    return (
      <p className="p-6 text-sm text-destructive">
        Ошибка при поиске товара: {String(isErrorItems)}
      </p>
    )
  }

  const filteredItems = getItemsWithoutCheckout(items, checkoutItems)

  if (!filteredItems || !filteredItems.length) {
    return <p className="p-6 text-sm text-muted-foreground">Товар не найден</p>
  }

  return <ItemStackedList items={filteredItems} onClickItem={onClickItemRow} />
}
